import React, { Component } from 'react';

import IconSetEthic from '../Icon/IconSetEthic';
import SectionList from './Section/SectionList';
import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';


class SectionEthic extends Component {

  render() {

    const { $$data, barOffset, horizontalOffset, width } = this.props;

    const align = 'right';
    const barColor = '#e24b4b';

    const listProps = {id: 'ethique', data: $$data, barOffset, align, className: 'SectionEthic', title: 'L\'Ethique', titleIcon: 'ethic', titleColor: '#6b6b6b', sectionBg: true, titleSize: width};
    return (
      <SectionList header={<div style={{height: 140}}>
        <SectionCorner length={50} style={{marginLeft: barOffset*-1}} corner={'br'} color={barColor} />
        <SectionBar length={Math.round(barOffset/2*3)} style={{top: 48, marginLeft: ((barOffset-horizontalOffset)*-1)}} color={barColor} direction={'horizontal'}/>
        <SectionCorner length={50} style={{top: 58, marginLeft: ((barOffset-58))}} corner={'tr'} color={barColor}/>
      </div>
    } barColor={barColor} footer={<div key="0" className="footer">
    <div className="icons">
    <IconSetEthic icon="cnil" width={width} />
    <IconSetEthic icon="diversite" width={width} />
    <IconSetEthic icon="rgpd" width={width} />
    </div>
      <SectionBar length={120} style={{top: 0, position: 'absolute', marginLeft: ((barOffset))}} color={barColor} direction={'vertical'}/>
  </div>}style={this.props.style || {}} {...listProps}  />
);
}
}

export default SectionEthic;



// WEBPACK FOOTER //
// ./src/components/Home/SectionEthic.jsx